var map = {
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/addusers/addusers.module": [
		"./src/app/pages/addusers/addusers.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-addusers-addusers-module"
	],
	"./pages/allocate-expenditure/allocate-expenditure.module": [
		"./src/app/pages/allocate-expenditure/allocate-expenditure.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-allocate-expenditure-allocate-expenditure-module"
	],
	"./pages/approvalpendingallote/approvalpendingallote.module": [
		"./src/app/pages/approvalpendingallote/approvalpendingallote.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-approvalpendingallote-approvalpendingallote-module"
	],
	"./pages/approvalpendingpaymentlist/approvalpendingpaymentlist.module": [
		"./src/app/pages/approvalpendingpaymentlist/approvalpendingpaymentlist.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-approvalpendingpaymentlist-approvalpendingpaymentlist-module"
	],
	"./pages/approvalpendingvendorslist/approvalpendingvendorslist.module": [
		"./src/app/pages/approvalpendingvendorslist/approvalpendingvendorslist.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-approvalpendingvendorslist-approvalpendingvendorslist-module"
	],
	"./pages/approvedallotlist/approvedallotlist.module": [
		"./src/app/pages/approvedallotlist/approvedallotlist.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-approvedallotlist-approvedallotlist-module"
	],
	"./pages/approvedpaymentlist/approvedpaymentlist.module": [
		"./src/app/pages/approvedpaymentlist/approvedpaymentlist.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-approvedpaymentlist-approvedpaymentlist-module"
	],
	"./pages/approvedvendorslist/approvedvendorslist.module": [
		"./src/app/pages/approvedvendorslist/approvedvendorslist.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-approvedvendorslist-approvedvendorslist-module"
	],
	"./pages/approvepayment/approvepayment.module": [
		"./src/app/pages/approvepayment/approvepayment.module.ts",
		"pages-approvepayment-approvepayment-module"
	],
	"./pages/approvevendor/approvevendor.module": [
		"./src/app/pages/approvevendor/approvevendor.module.ts",
		"pages-approvevendor-approvevendor-module"
	],
	"./pages/bulkupload/bulkupload.module": [
		"./src/app/pages/bulkupload/bulkupload.module.ts",
		"pages-bulkupload-bulkupload-module"
	],
	"./pages/change-password/change-password.module": [
		"./src/app/pages/change-password/change-password.module.ts",
		"default~pages-change-password-change-password-module~pages-editvendor-editvendor-module~pages-myprof~5babd3a4",
		"pages-change-password-change-password-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"default~pages-dashboard-dashboard-module~pages-not-found-404-not-found-404-module~pages-undermainten~a844676a",
		"pages-dashboard-dashboard-module"
	],
	"./pages/deactivatedoffices/deactivatedoffices.module": [
		"./src/app/pages/deactivatedoffices/deactivatedoffices.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-deactivatedoffices-deactivatedoffices-module"
	],
	"./pages/deactivateusers/deactivateusers.module": [
		"./src/app/pages/deactivateusers/deactivateusers.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-deactivateusers-deactivateusers-module"
	],
	"./pages/dscregistration/dscregistration.module": [
		"./src/app/pages/dscregistration/dscregistration.module.ts",
		"pages-dscregistration-dscregistration-module"
	],
	"./pages/editvendor/editvendor.module": [
		"./src/app/pages/editvendor/editvendor.module.ts",
		"default~pages-change-password-change-password-module~pages-editvendor-editvendor-module~pages-myprof~5babd3a4",
		"pages-editvendor-editvendor-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/list/list.module": [
		"./src/app/pages/list/list.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-list-list-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/logout/logout.module": [
		"./src/app/pages/logout/logout.module.ts",
		"pages-logout-logout-module"
	],
	"./pages/manage_dsc/manage_dsc.module": [
		"./src/app/pages/manage_dsc/manage_dsc.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-manage_dsc-manage_dsc-module"
	],
	"./pages/manageoffices/manageoffices.module": [
		"./src/app/pages/manageoffices/manageoffices.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-manageoffices-manageoffices-module"
	],
	"./pages/manageusers/manageusers.module": [
		"./src/app/pages/manageusers/manageusers.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-manageusers-manageusers-module"
	],
	"./pages/myprofile/myprofile.module": [
		"./src/app/pages/myprofile/myprofile.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"default~pages-change-password-change-password-module~pages-editvendor-editvendor-module~pages-myprof~5babd3a4",
		"pages-myprofile-myprofile-module"
	],
	"./pages/not-found-404/not-found-404.module": [
		"./src/app/pages/not-found-404/not-found-404.module.ts",
		"default~pages-dashboard-dashboard-module~pages-not-found-404-not-found-404-module~pages-undermainten~a844676a",
		"pages-not-found-404-not-found-404-module"
	],
	"./pages/officecreate/officecreate.module": [
		"./src/app/pages/officecreate/officecreate.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-officecreate-officecreate-module"
	],
	"./pages/signup/signup.module": [
		"./src/app/pages/signup/signup.module.ts",
		"pages-signup-signup-module"
	],
	"./pages/transactionhistory/transactionhistory.module": [
		"./src/app/pages/transactionhistory/transactionhistory.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"pages-transactionhistory-transactionhistory-module"
	],
	"./pages/unauthorized/unauthorized.module": [
		"./src/app/pages/unauthorized/unauthorized.module.ts",
		"pages-unauthorized-unauthorized-module"
	],
	"./pages/undermaintenance/undermaintenance.module": [
		"./src/app/pages/undermaintenance/undermaintenance.module.ts",
		"default~pages-dashboard-dashboard-module~pages-not-found-404-not-found-404-module~pages-undermainten~a844676a",
		"pages-undermaintenance-undermaintenance-module"
	],
	"./pages/vendor-register/vendor-register.module": [
		"./src/app/pages/vendor-register/vendor-register.module.ts",
		"default~pages-addusers-addusers-module~pages-allocate-expenditure-allocate-expenditure-module~pages-~1993e81b",
		"default~pages-change-password-change-password-module~pages-editvendor-editvendor-module~pages-myprof~5babd3a4",
		"pages-vendor-register-vendor-register-module"
	],
	"./pages/vendorpaymentcreation/vendorpaymentcreation.module": [
		"./src/app/pages/vendorpaymentcreation/vendorpaymentcreation.module.ts",
		"pages-vendorpaymentcreation-vendorpaymentcreation-module"
	],
	"./pages/vendorslist/vendorslist.module": [
		"./src/app/pages/vendorslist/vendorslist.module.ts",
		"pages-vendorslist-vendorslist-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;